videojs.addLanguage('fi', 
 {
  "Play": "Play",
  "Pause": "Pause",
  "Current Time": "Current Time",
  "Duration Time": "Duration Time",
  "Remaining Time": "Remaining Time",
  "Stream Type": "Stream Type",
  "LIVE": "LIVE",
  "Loaded": "Loaded",
  "Progress": "Progress",
  "Fullscreen": "Fullscreen",
  "Non-Fullscreen": "Non-Fullscreen",
  "Mute": "Mute",
  "Unmuted": "Unmuted",
  "Playback Rate": "Playback Rate",
  "Subtitles": "Subtitles",
  "subtitles off": "subtitles off",
  "Captions": "Captions",
  "captions off": "captions off",
  "Chapters": "Chapters",
  "You aborted the video playback": "You aborted the video playback.",
  "A network error caused the video download to fail part-way.": "Videon toisto katkesi yllättäen, ole hyvä ja tarkasta nettiyhteytesi.",
  "The video could not be loaded, either because the server or network failed or because the format is not supported.": "Elokuvatiedoston viallinen tai selaimesi ei tue formaattia.",
  "The video playback was aborted due to a corruption problem or because the video used features your browser did not support.": "Tämä elokuvatiedosto ei joko ole saatavilla, tai sitten selaimesi ei tue formaattia.",
  "No compatible source was found for this video.": "Elokuvaa  ei ole ladattu."
});